module.exports = __webpack_public_path__ + "img/dgjg2332_1.bdcc5029.svg";